<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tooltip">
          <v-btn class="cvc-button delete-notification-button mx-2" v-on="on" elevation="4" :disabled="disabled" color="error">
            <div v-bind="tooltip.attrs" v-on="tooltip.on">
              <v-icon>mdi-trash-can</v-icon>
            </div>
          </v-btn>
        </template>
        <span>Delete</span>
      </v-tooltip>
    </template>

    <v-card color="colorf">
      <v-card-title>
        <span class="pl-2 pt-2 font-size-medium-large font-weight-medium">
          Are you sure?
        </span>
      </v-card-title>
      <v-card-text class="mt-3">
        <span>
          Delete the notification titled '{{notification.action.action.payload.title}}'?
        </span>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="sendingMessage"
          class="cvc-button"
          depressed width="100px"
          @click="hideDialogForNotification">
          No
        </v-btn>
        <v-btn
          :disabled="sendingMessage"
          class="cvc-button"
          depressed width="100px"
          @click="deleteNotification">
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteNotificationModal",
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: null,
      disabled: false,
      sendingMessage: false
    }
  },
  methods: {
    deleteNotification() {
      this.sendingMessage = true;
      this.$store
        .dispatch("deleteProfileActionNotification", {
          action_v2_id: this.notification.action._id.$oid,
          sent_action_id: this.notification.action_id,
        })
        .finally(() => {
          this.sendingMessage = false;
          this.disableButton();
          this.hideDialogForNotification();
        });
    },
    hideDialogForNotification() {
      this.dialog = false;
    },
    disableButton() {
      this.disabled = true;
    },
  }
}
</script>

<style scoped>
  .delete-notification-button {
    height: 36px !important;
    border-radius: 4px !important;
  }
</style>